import React, { FC } from 'react'
import MediaMenuItem from '../../MediaMenu/MediaMenuItem'
import { IconType } from '@bt-react/components/Icon'
import { StreamButtonProps } from './types'

const StreamButton: FC<StreamButtonProps> = ({
  isActive,
  onStreamClick
}) =>
  <MediaMenuItem
    onClick={onStreamClick}
    dataBdd={'talks-stream-button'}
    active={isActive}
    icon={IconType.iconName.signalStream}
    text={`Stream`}
    disabled={false}
  />

export default StreamButton